import { getStatusSearchReport } from "../../services/ReportService/ReportService";
import StageSearchReportTable from "./StageSearchReportTable";

const StageSearchReport = () => {
  return (
    <StageSearchReportTable
      fetchData={getStatusSearchReport}
      exportFileNamePrefix="OMC-wise Pendency Report"
    />
  );
};

export default StageSearchReport;
